module.exports = __webpack_public_path__ + "resources/img/m_banner4_v3.ef70dffd8626e327071dedec1945f631.png";